import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-copyright",
  "use": "icon-copyright-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-copyright\"><path d=\"M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0zm0 1.077a5.923 5.923 0 1 0 0 11.846A5.923 5.923 0 0 0 7 1.077zm.18 2.872c.873 0 1.691.349 2.292.954l.077.08-.79.733a2.154 2.154 0 1 0-.069 2.999l.07-.072.79.733a3.23 3.23 0 1 1-2.37-5.427z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol